import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function PlatformSection() {
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate(`/article/${slug}`), 150);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">合作视频平台</h2>
          <p className="text-foreground-600 text-sm">聚合全网主流影视平台资源，一站式追剧观影</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-10">
          {[
            { name: '妖精视频', color: 'bg-pink-500' },
            { name: '桃花视频', color: 'bg-rose-400' },
            { name: '苹果视频', color: 'bg-red-500' },
            { name: '榴莲视频', color: 'bg-amber-500' },
            { name: '豆花视频', color: 'bg-orange-400' },
          ].map((p) => (
            <div
              key={p.name}
              className="flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-secondary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${p.color} text-white`}>
                <i className="ri-play-fill text-lg"></i>
              </div>
              <span className="text-sm font-medium text-foreground-800">{p.name}</span>
            </div>
          ))}
        </div>
        <div className="text-center">
          <h3 className="text-lg font-bold text-foreground-950 mb-6">最新影视资讯</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {articles.slice(0, 3).map((article) => (
              <div
                key={article.id}
                className="flex gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                onClick={() => handleArticleClick(article.slug)}
              >
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-24 h-16 rounded object-cover shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground-900 line-clamp-2 mb-1 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h4>
                  <p className="text-xs text-foreground-500">{article.publishDate} · {article.author}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}